import React, { useContext, useState } from 'react';
import { Button, Form, FormControl, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { UserContext } from '../../App';
import css from './Header.css';

const Header = () => {
    const [loggedInUser , setLoggedInUser] = useContext(UserContext);



    return (
        <div className="topnav" id="myTopnav">
            {/* <img src={logo} alt=""/> */}
           
                
       

               






                <nav className="navbar navbar-expand navbar-light text-light bg-info">
                    <a className="navbar-brand" href="/">Xber Ride</a>
                    {/* <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button> */}
                    <div className="collapse navbar-collapse" id="navbarText">
                        <ul className="navbar-nav mr-auto">
                        <li class="nav-item active">
                            <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/login">Destination</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" href="/login">Login</Link>
                        </li>
                        </ul>
                        <Link className="a" href="javascript:void(0);" class="icon" onclick="myFunction()">
                        <i class="fa fa-bars"></i>
                        </Link>
                        <span className="navbar-text">
                        <span className="a" style={{color:'blue' }}>{loggedInUser.name}</span>
                        </span>
                    </div>
                    </nav>




                {/* <Link to="/inventory">Manage Inventory</Link> */}
                
           
           
            
        </div>
    );
};

export default Header;